// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/files/gdrive.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GDriveConnectButton{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    gap: 20px;
    padding: 20px 0px;
}

.GDriveConnectButton_logo{
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 64px;
    height: 64px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.GDriveConnectButton_text{

}

.GDriveConnectButton_button{
    border-radius: 20px;
    padding: 10px;
    border: 1px solid #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/desktopPage/GDriveConnectButton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,yDAAsD;AAC1D;;AAEA;;AAEA;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".GDriveConnectButton{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    text-align: center;\n    gap: 20px;\n    padding: 20px 0px;\n}\n\n.GDriveConnectButton_logo{\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 64px;\n    height: 64px;\n    background-image: url(\"../../assets/files/gdrive.svg\");\n}\n\n.GDriveConnectButton_text{\n\n}\n\n.GDriveConnectButton_button{\n    border-radius: 20px;\n    padding: 10px;\n    border: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
